import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";

export default class ApplyRetailerTagsPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    console.debug("ApplyRetailerTagsPromptController", { $ctrl, options });
    const { request = {}, title } = options;

    $ctrl.request = {
      tags: {},
      ...request
    };
    $ctrl.title = title;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.model = $ctrl;
    $ctrl.tagKinds = [];
  }


  submit() {
    const $ctrl = this;
    $ctrl.bus
      .send("ApplyRetailerTags.json?Profiler=Enabled", $ctrl.request)
      .then(res => $ctrl.$close(res));
  }
}
